import { isEmpty } from 'lodash-es';
import React from 'react';

import { SimpleTextToggle } from '~/src/dash/components/toggles/SimpleTextToggle';
import { Col, Cols, spacing } from '~/src/dash/publicaUI';
import { DateRange, defaultDateRanges, findDateRange } from '~/src/dash/utils/dateTimeRanges';
import { IActiveFilters } from '~/src/dash/views/dashboards/DashboardHome/common/common';

interface IDateGroup {
  label: string;
  value: number;
}

const dateGroups = [
  { label: 'Hour', value: 0 },
  { label: 'Day', value: 1 },
  { label: 'Week', value: 2 },
  { label: 'Month', value: 3 },
] as IDateGroup[];

interface IDateGroupSelectorProps {
  activeDateRange: DateRange;
  activeGrouping: number;
  handleSelectGrouping: (dateGroup: number) => void;
}

export const DateGroupSelector = ({
  activeDateRange,
  activeGrouping,
  handleSelectGrouping,
}: IDateGroupSelectorProps) => {
  const { dateGroupRange } = findDateRange(activeDateRange) || defaultDateRanges[0]; // TODO: INVESTIGATE BETTER UNDEFINED DEFAULT
  const [min, max] = dateGroupRange;
  return (
    <Cols
      gap={spacing.large}
      style={{
        justifyContent: 'center',
        alignContent: 'center',
      }}
    >
      {dateGroups.map((group) => {
        const isAllowed = group.value >= min && group.value <= max;
        return (
          <Col>
            <SimpleTextToggle
              active={activeGrouping === group.value}
              disabled={!isAllowed}
              onClick={() => handleSelectGrouping(group.value)}
              value={group.label}
            />
          </Col>
        );
      })}
    </Cols>
  );
};

export enum EMobileFilter {
  None,
  Filters,
  Calendar,
}

export const isAnyFilterActive = (activeFilters: IActiveFilters) => {
  return Object.values(activeFilters).some((value) => !isEmpty(value));
};
